// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { ReportBuilderTab } from 'NewAngular/enums/report-builder-tabs.enum';
// NgRx actions
import { setActiveTab } from './active-tab.action';
export const active_tab = createReducer(ReportBuilderTab.PAGE_PREVIEW, on(setActiveTab, (state, action) => {
    return action.tab;
}));
